import React from "react";
import { AlertTriangle, X } from "lucide-react";

const DeleteModal = ({
  isOpen = false,
  onClose = () => {},
  btnFnc = () => {},
}) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] bg-slate-900/40 backdrop-blur-xs flex items-center justify-center p-4 transition-all duration-200"
      onClick={handleOverlayClick}
    >
      <div
        className="bg-white rounded-2xl shadow-xl max-w-md w-full p-6 sm:p-8 relative border border-slate-100 transform transition-all animate-in fade-in zoom-in-95 duration-150"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button Icon */}
        <button
          onClick={onClose}
          type="button"
          className="absolute top-4 right-4 text-slate-400 hover:text-slate-600 p-1.5 rounded-lg hover:bg-slate-100 transition-colors"
        >
          <X className="w-4 h-4" />
        </button>

        {/* Lucide Warning Icon Container */}
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-rose-50 border border-rose-100 mb-4">
          <AlertTriangle className="h-6 w-6 text-rose-600" />
        </div>

        {/* Modal Text Content */}
        <div className="text-center space-y-2">
          <h2 className="text-lg font-bold text-slate-900 tracking-tight">
            Are you sure you want to delete?
          </h2>
          <p className="text-xs sm:text-sm text-slate-500 font-normal leading-relaxed">
            This action cannot be undone. This item will be permanently removed.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex items-center justify-center gap-3 mt-6">
          <button
            type="button"
            onClick={onClose}
            className="w-1/2 py-2.5 px-4 text-xs sm:text-sm font-semibold text-slate-700 bg-slate-100 hover:bg-slate-200/80 rounded-xl transition-all active:scale-95 border border-slate-200/60"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => {
              onClose();
              btnFnc();
            }}
            className="w-1/2 py-2.5 px-4 text-xs sm:text-sm font-semibold text-white bg-rose-600 hover:bg-rose-700 rounded-xl shadow-xs transition-all active:scale-95"
          >
            Confirm Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
